import type { ClassOccurrence } from '../../api/generated/model';

/**
 * Antecedencia minima para o professor desmarcar. Espelha a janela que
 * `api/internal/scheduling/service.go` aplica antes de devolver 409.
 */
export const TEACHER_CANCEL_NOTICE_MS = 24 * 60 * 60 * 1000;

/**
 * O professor ainda esta dentro do prazo de desmarcar esta aula?
 *
 * Antes isto lia `occ.teacherCanCancel` por um `as`, e **esse campo nao existe
 * no contrato**: `ClassOccurrence` nao o declara e resposta nenhuma do servidor
 * o traz. Quem o produzia era o dublê MSW, e so ele — entao em producao a
 * leitura era sempre `undefined`, o `undefined` virava `true`, o aviso das 24 h
 * nunca aparecia e o botao nunca desabilitava. O teste da agenda passava
 * justamente porque provava o dublê, mais generoso que o servidor real.
 *
 * A conta local usa o unico dado que o contrato garante — `startsAtUtc` — e e a
 * mesma que o servidor faz. Ela pode divergir do servidor por segundos de
 * relogio, e isso e aceitavel: quem decide continua sendo o 409, que a tela
 * agora mostra. A alternativa recusada foi manter o `as` e pedir o campo ao
 * contrato: enquanto o aditivo nao existe, o `as` desliga a protecao em silencio
 * — que e exatamente o defeito que ele parecia impedir.
 */
export function readTeacherCanCancel(occ: ClassOccurrence, now: number = Date.now()): boolean {
  return Date.parse(occ.startsAtUtc) - now >= TEACHER_CANCEL_NOTICE_MS;
}
